var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field",class:{ 'field--error': _vm.error }},[(_vm.label)?_c('span',{ref:"leftRef",staticClass:"left"},[_c('h6',[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right",style:({ width: _setup.rightWidth })},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }